import { BulkAddRoleAuthorizationResponse, RoleOption } from '../types/models/roleAuthorization.models';

export const normalizeBulkAddRoleAuthorizationResponse = (raw: any): BulkAddRoleAuthorizationResponse => {
    const payload = raw?.data ?? raw?.model ?? raw ?? {};

    return {
        addedCount: Number(payload.addedCount ?? payload.AddedCount ?? 0) || 0,
        skippedCount: Number(payload.skippedCount ?? payload.SkippedCount ?? 0) || 0,
        skippedRoleIds: payload.skippedRoleIds ?? payload.SkippedRoleIds,
        skippedRoleNames: payload.skippedRoleNames ?? payload.SkippedRoleNames ?? [],
    };
};

export const formatSkippedRoleNamesFromResponse = (
    response: BulkAddRoleAuthorizationResponse,
    roles: RoleOption[] = []
): string => {
    if (response.skippedRoleNames?.length) {
        return response.skippedRoleNames.join(', ');
    }

    if (response.skippedRoleIds?.length) {
        return response.skippedRoleIds
            .map((roleId) => roles.find((item) => item.roleId === roleId)?.roleNameKey)
            .filter(Boolean)
            .join(', ');
    }

    return '';
};
